import { defineMessages } from 'react-intl';

const idPrefix = 'dashboardEdit.';

export const messages = defineMessages({
  dataLoadingText: {
    id: `${idPrefix}dataLoadingText`,
    defaultMessage: 'Loading...',
  },
  dashboardHeadingText: {
    id: `${idPrefix}dashboardHeadingText`,
    defaultMessage: 'Dashboard',
  },
  revertToDefaultButtonText: {
    id: `${idPrefix}revertToDefaultButtonText`,
    defaultMessage: 'Revert to Default',
  },
  addNewCardButtonText: {
    id: `${idPrefix}addNewCardButtonText`,
    defaultMessage: 'Add new card',
  },
  cancelEditButtonText: {
    id: `${idPrefix}cancelEditButtonText`,
    defaultMessage: 'Cancel edit mode',
  },
  editDashboardButtonText: {
    id: `${idPrefix}editDashboardButtonText`,
    defaultMessage: 'Edit Dashboard',
  },
  doneEditingButtonText: {
    id: `${idPrefix}doneEditingButtonText`,
    defaultMessage: 'Done Editing',
  },
  addnewCardHeadingText: {
    id: `${idPrefix}addnewCardHeadingText`,
    defaultMessage: 'Add new card',
  },
  addNewCardFooterAddButtonText: {
    id: `${idPrefix}addNewCardFooterAddButtonText`,
    defaultMessage: 'Add',
  },
  addNewCardFooterCancelButtonText: {
    id: `${idPrefix}addNewCardFooterCancelButtonText`,
    defaultMessage: 'Cancel',
  },
});

export default messages;



